import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from 'react-intl';

const Instructor = ({className, firstName, lastName, avatar, bio}) => {
  return (
    <div className={className}>
      <div className="tr">
        {avatar && (
          <div className="pa1 tr">
            {avatar && (
              <img
                src={typeof avatar === 'object' ? avatar.url : avatar}
                className="dib v-mid br-100 h3 w3"
                alt="avatar"
              />
            )}
            <div className="dib v-mid dark-gray ph2">
              <div className="f6 fw4 mb2">
                <FormattedMessage id="instructor" />
              </div>
              <h4 className="f6 fw6" data-cy="instructor-name">
                {`${firstName} ${lastName}`}
              </h4>
            </div>
          </div>
        )}
        <p
          className="gray tr mt3 pv3 f6"
          dangerouslySetInnerHTML={{__html: bio}}
        />
      </div>
    </div>
  );
};

Instructor.propTypes = {
  avatar: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  bio: PropTypes.string.isRequired,
  className: PropTypes.string,
  firstName: PropTypes.string.isRequired,
  lastName: PropTypes.string.isRequired,
};

export default Instructor;
